/**
 * Platform roles. Mirrors app/core/constants.py on the backend -- keep both
 * in sync when a role is added.
 */
export const USER_ROLES = {
  STUDENT: 'STUDENT',
  COMPANY: 'COMPANY',
  SUPER_ADMIN: 'SUPER_ADMIN',
};

/**
 * Roles inside a company workspace. What each one grants is set per company
 * (Team -> Roles and permissions); never test these to decide what to show --
 * use `can(...)`.
 */
export const COMPANY_ROLES = {
  COMPANY_ADMIN: 'COMPANY_ADMIN',
  HR: 'HR',
  RECRUITER: 'RECRUITER',
  HIRING_MANAGER: 'HIRING_MANAGER',
};

/**
 * Permission codes the client checks with `can(...)`. Mirrors
 * app/core/permissions.py; only the ones a screen actually tests are listed.
 */
export const PERMISSIONS = {
  COMPANY_PROFILE_UPDATE: 'company.profile.update',
  COMPANY_BRANDING_UPDATE: 'company.branding.update',
  COMPANY_MEMBERS_MANAGE: 'company.members.manage',
  INTERNSHIP_READ: 'internship.read',
  INTERNSHIP_CREATE: 'internship.create',
  INTERNSHIP_UPDATE: 'internship.update',
  INTERNSHIP_PUBLISH: 'internship.publish',
  INTERNSHIP_DELETE: 'internship.delete',
  APPLICATION_READ: 'application.read',
  APPLICATION_UPDATE: 'application.update',
  CANDIDATE_READ: 'candidate.read',
  CANDIDATE_SHORTLIST: 'candidate.shortlist',
  CANDIDATE_REJECT: 'candidate.reject',
  // Listing interviews and offers is guarded by the create permission.
  INTERVIEW_CREATE: 'interview.create',
  INTERVIEW_UPDATE: 'interview.update',
  OFFER_CREATE: 'offer.create',
  OFFER_UPDATE: 'offer.update',
  MESSAGE_READ: 'message.read',
  MESSAGE_SEND: 'message.send',
  ANALYTICS_READ: 'analytics.read',
  SUBSCRIPTION_READ: 'subscription.read',
  ATS_READ: 'ats.read',
};
